<template>
    <main>
        <Head>
            <title>{{ post.meta_title }}</title>
            <meta name="description" :content="post.meta_description" inertia="description" />
            <link rel="preload" as="image" :href="post.headerImage.origin_src" />
        </Head>

        <div class="bg-gray-50 w-full pb-6">
            <div
                v-if="showResource"
                class="bg-red-500/10 text-red-500 my-4 text-center py-2 rounded-md mx-auto max-w-2xl"
            >
                Pagina is uitgeschakeld.
            </div>
            <div class="max-w-(--breakpoint-2xl) container mx-auto px-6 lg:px-8 pb-8">
                
                <Breadcrumbs class="py-4" />

                <!-- Content -->
                <div class="flex flex-wrap w-full">
                    <div class="hidden md:block w-full md:w-1/3">
                        <!-- <Author :category="category" class="hidden md:block" /> -->

                        <div style="position: sticky !important; top: 160px !important">
                            <ul class="mt-8 hidden md:block" id="quickLinks">
                                <li
                                    v-for="link in links"
                                    :key="link.id"
                                    class="pl-4 border-transparent border-l-4 py-2 transition-all hover:text-gray-700 cursor-pointer text-gray-500"
                                    v-scroll-to="{ offset: -200, el: '#' + link.id, container: 'html', duration: 200 }"
                                    v-html="link.title"
                                ></li>
                                <li
                                    v-if="faqs.length"
                                    class="pl-4 border-transparent border-l-4 py-2 transition-all hover:text-gray-700 cursor-pointer text-gray-500"
                                    v-scroll-to="{ offset: -200, el: '#faq', container: 'html', duration: 200 }"
                                >
                                    Veelgestelde vragen
                                </li>
                            </ul>
                        </div>

                        <!-- <AdviceMenu :categories="categories" /> -->
                    </div>

                    <div class="w-full md:w-2/3 2xl:pr-48">
                        <h1 class="text-2xl font-bold my-2 block mt-4">{{ post.title }}</h1>

                        <div class="rounded-lg px-4 py-2 bg-dgreen4 text-gray-800 text-sm mt-4">
                            <span class="border-r pr-4 border-gray-800">Door {{ category.author }}</span>
                            <span class="border-r px-4 border-gray-800">Geschreven: {{ post.human_date }}</span>
                            <span class="px-4 border-gray-800">Laatst gewijzigd: {{ post.human_date_changed }}</span>
                        </div>

                        <AdviceHeader :post="post" class="mt-8" />

                        <div class="md:hidden block mt-6 space-y-2">
                            <strong>Inhoudsopgave</strong>
                            <ul>
                                <li
                                    v-for="link in links"
                                    class="link"
                                    v-scroll-to="{ offset: -200, el: '#' + link.id, container: 'html', duration: 200 }"
                                    v-html="link.title"
                                ></li>
                                <li
                                    v-if="faqs.length"
                                    class="link"
                                    v-scroll-to="{ offset: -200, el: '#faq', container: 'html', duration: 200 }"
                                >
                                    Veelgestelde vragen
                                </li>
                            </ul>
                        </div>

                        <AdviceBlock :body="post.body" :image="post.images.image_1" :products="post.products" />
                        <AdviceBlock :body="post.body_2" :image="post.images.image_2" :products="post.products_2" />
                        <AdviceBlock :body="post.body_3" :image="post.images.image_3" :products="post.products_3" />
                        <AdviceBlock
                            :body="post.body_4"
                            v-if="post.body_4 != ''"
                            :image="post.images.image_4"
                            :products="post.products_4"
                        />
                        <AdviceBlock
                            :body="post.body_5"
                            v-if="post.body_5 != ''"
                            :image="post.images.image_5"
                            :products="post.products_5"
                        />
                        <AdviceBlock
                            :body="post.body_6"
                            v-if="post.body_6 != ''"
                            :image="post.images.image_6"
                            :products="post.products_6"
                        />
                        <AdviceBlock
                            :body="post.body_7"
                            v-if="post.body_7 != ''"
                            :image="post.images.image_7"
                            :products="post.products_7"
                        />
                        <AdviceBlock
                            :body="post.body_8"
                            v-if="post.body_8 != ''"
                            :image="post.images.image_8"
                            :products="post.products_8"
                        />

                        <Author :category="category" :wide="true" />
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-white w-full pb-6">
            <div class="max-w-(--breakpoint-2xl) container mx-auto px-4 lg:px-4 pt-4 pb-8 border-t">
                <div class="flex flex-wrap w-full">
                    <div class="w-full md:w-1/3 pt-12">
                        <WizardIntro />
                    </div>
                    <div class="w-full md:w-2/3 pt-4" id="faq">
                        <Faqs :faqs="faqs" />
                    </div>
                </div>
            </div>
        </div>

        <ServiceFooter :post="post" />

        <div v-if="schemaOrg" v-html="schemaOrg"></div>
    </main>
</template>

<script setup>
import Author from '@/Components/Advice/Author.vue';
import AdviceBlock from '@/Components/Advice/Block.vue';
import AdviceHeader from '@/Components/Advice/Header.vue';
import Faqs from '@/Components/Service/Faqs.vue';
import ServiceFooter from '@/Components/Service/Footer.vue';
import { onMounted } from 'vue';

const props = defineProps({
    post: Object,
    links: Object,
    category: Object,
    faqs: Array,
    schemaOrg: [String, Boolean],
    showResource: Boolean,
});

onMounted(function () {
    const links = document.querySelectorAll('#quickLinks > li');
    const sections = document.querySelectorAll('h2.quicklink');

    function changeLinkState() {
        let active = false;
        let index = sections.length;
        while (--index && window.scrollY + 300 < sections[index].offsetTop) {}
        links.forEach((link) => link.classList.remove('active'));
        if (links[index]) {
            links[index].classList.add('active');
            active = true;
        }
        if (!active) {
            links[links.length - 1].classList.add('active');
        }
    }
    if (sections.length > 0) {
        changeLinkState();
        window.addEventListener('scroll', changeLinkState);
    }
});
</script>

<style scoped>
.layout {
    scroll-behavior: smooth;
}
.active {
    font-weight: bold;
    border-color: #07589f;
    color: #333;
}
</style>
